import React from "react";
import { LanguageSelector } from "../../../../components/Component";

const LangSelector = () => {
	return <LanguageSelector />;
};

export default LangSelector;
